import { useControlResultRepository } from "@/shared/contexts/repository-context";
import { getGetControlResultActivitiesQueryKey } from "@/spz-api/control-results/control-results";
import { useQuery } from "@tanstack/react-query";

export const useControlResultActivityListing = (
  controlId: string,
  resultId: string,
) => {
  const controlResultRepository = useControlResultRepository();
  const { data, isLoading } = useQuery({
    queryKey: getGetControlResultActivitiesQueryKey(controlId, resultId),
    queryFn: () =>
      controlResultRepository.getControlResultActivities(controlId, resultId),
  });
  return {
    data: data ?? [],
    isLoading,
  };
};
